import type { SelectOption } from "@/components/basics/Select.vue";
import { findOptionByLabel } from "@/services/selectHelpers";

enum PossibleInputType {
  Select,
  TextInput,
}

type Config = {
  possibleOptions?: SelectOption[];
  originalValue: string | null | number;
};

export function useParamInput(config: Config) {
  const {
    possibleOptions = undefined, //
    originalValue = null,
  } = config;

  const inputType = computed((): PossibleInputType => {
    if (possibleOptions !== undefined && possibleOptions.length > 0) {
      if (originalValue === null) {
        return PossibleInputType.Select;
      } else if (typeof originalValue === "number") {
        return PossibleInputType.Select;
      } else {
        const option = findOptionByLabel(originalValue, possibleOptions);
        if (option) {
          return PossibleInputType.Select;
        } else {
          return PossibleInputType.TextInput;
        }
      }
    } else {
      return PossibleInputType.TextInput;
    }
  });

  const isSelect = computed(() => inputType.value === PossibleInputType.Select);
  const isTextInput = computed(() => inputType.value === PossibleInputType.TextInput);

  return {
    isSelect,
    isTextInput,
  };
}
